import { render } from "./MoreToolsCollapsible.vue?vue&type=template&id=38a82c2c&scoped=true"
import script from "./MoreToolsCollapsible.vue?vue&type=script&lang=js"
export * from "./MoreToolsCollapsible.vue?vue&type=script&lang=js"

import "./MoreToolsCollapsible.vue?vue&type=style&index=0&id=38a82c2c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a82c2c"]])

export default __exports__